import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=5563c30c&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=ts"
export * from "./statistics.vue?vue&type=script&lang=ts"
import style0 from "./statistics.vue?vue&type=style&index=0&id=5563c30c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563c30c",
  null
  
)

export default component.exports